











































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { VueConstructor } from 'vue';
import TrButton from './TrButton.vue';
import { Size } from '../constants';
import { ButtonPalettes } from './palettes';

const PaletteClasses: Record<ButtonPalettes, string> = {
	[ButtonPalettes.CRITICAL]: 'cta-button--critical-palette',
	[ButtonPalettes.SUBDUED]: 'cta-button--subdued-palette',
	[ButtonPalettes.PRIMARY]: 'cta-button--primary-palette',
	[ButtonPalettes.SUCCESS]: 'cta-button--success-palette',
	[ButtonPalettes.DEFAULT]: '',
};

export default defineComponent({
	components: { TrButton },
	props: {
		tag: {
			type: String as PropType<null | string | VueConstructor>,
			default: undefined,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
		palette: {
			type: Number as PropType<ButtonPalettes>,
			default: ButtonPalettes.SUBDUED,
		},
		disabled: Boolean,
		isLoading: Boolean,
		isLink: Boolean,
		isSolid: Boolean,
		isActive: Boolean,
		isMerged: Boolean,
		isReversed: Boolean,
		hasIcon: Boolean,
		wrap: Boolean,
	},
	setup(props, ctx) {
		const is = computed(() => (props.tag ? props.tag : TrButton));
		const paletteClass = computed(() => PaletteClasses[props.palette]);
		const nonClickListeners = computed(() => Object.entries(ctx.listeners)
			.filter(([key]) => key !== 'click')
			.reduce((acc, [key, val]) => {
				acc[key] = val;
				return acc;
			}, {} as Record<string, unknown | undefined>));
		const handleClick = (e: MouseEvent) => {
			if (props.isLoading || props.disabled) {
				e.stopPropagation();
				e.preventDefault();
				return;
			}
			ctx?.listeners.click?.(e);
		};
		return {
			is,
			Size,
			paletteClass,
			nonClickListeners,
			handleClick,
		};
	},
});
